export interface VideoItem {
  title:        string;
  description:  string;
  duration:     string;
  url:          string | null;
  thumbnailUrl?: string | null;
  jobAidUrl?:   string | null;
}

export const VIDEOS: VideoItem[] = [
  {
    title:       "Platform Overview",
    description: "A walkthrough of the AI Ready Ohio portal — pages, navigation, and key concepts.",
    duration:    "Coming soon",
    url:         null,
  },
  {
    title:       "Importing Certificates",
    description: "How to prepare and upload certificate files, handle validation errors, and review import results.",
    duration:    "Coming soon",
    url:         null,
  },
  {
    title:       "Managing People & Certificates",
    description: "How to search people, add LinkedIn URLs, review certificate tracking status, and take action on paused records.",
    duration:    "Coming soon",
    url:         null,
  },
  {
    title:       "Understanding Employment Tracking",
    description: "How the scraper detects company changes, what tracking statuses mean, and how to reactivate stopped certificates.",
    duration:    "Coming soon",
    url:         null,
  },
];
